module.exports = __webpack_public_path__ + "static/media/icon-business.1046c02f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/assets/icon-business.svg
// module id = 759
// module chunks = 20